import { render, staticRenderFns } from "./ShopInfoForm.vue?vue&type=template&id=8d7631e0&"
import script from "./ShopInfoForm.vue?vue&type=script&lang=js&"
export * from "./ShopInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./ShopInfoForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardText,VCol,VColorPicker,VDialog,VRow,VSwitch,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d7631e0')) {
      api.createRecord('8d7631e0', component.options)
    } else {
      api.reload('8d7631e0', component.options)
    }
    module.hot.accept("./ShopInfoForm.vue?vue&type=template&id=8d7631e0&", function () {
      api.rerender('8d7631e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShopInfo/components/ShopInfoForm.vue"
export default component.exports